import CustomWindow from 'interfaces/Utils';

declare let window: CustomWindow;

export default function logOut() {
  window.tp.pianoId.logout();
}
